import React, { useState } from 'react';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const jsonBinUrl = `https://api.jsonbin.io/v3/b`;  
    const jsonBinWriteToken = process.env.REACT_APP_JSONBIN_ACCESS_KEY 
    const jsonBinMasterToken = process.env.REACT_APP_JSONBIN_MASTER_KEY ;  
    
    fetch(jsonBinUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Master-Key': jsonBinMasterToken,
        'X-Access-Key': jsonBinWriteToken
      },
      body: JSON.stringify(formData)  
    })
    .then((response) => response.json())
    .then((data) => {
      console.log('Form submitted:', data);
      alert('Thank you for subscribing!');
      setFormData({
        firstName: '',
        lastName: '',
        email: ''
      });
    })
    .catch((error) => {
      console.error('Error submitting form:', error);
      alert('Oops! Something went wrong.');
    });
  };

  return (
    <div className="App">
      {/* Hero Section */}
      <header className="hero">
        <div className="hero-content">
          <img src="/Dark.jpg" alt="FitItFirst Logo" className="logo" />
          <h1>Welcome to FitItFirst</h1>
          <p>Perfect Fit. Fewer Returns. Happier Shoppers.</p>
        </div>
      </header>

      {/* Break Line Between Sections */}
      <hr className="section-break" />

      {/* What We Do Section */}
      <section className="description">
        <div className="content">
          <h2>How It Works</h2>
          <p>Simply upload your photos, we create your 3D avatar, and try on clothes by uploading links or images. Get the perfect fit every time!</p>
        </div>
      </section>

      {/* Break Line Between Sections */}
      <hr className="section-break" />

      {/* Subscription Form Section */}
      <section className="form-section">
        <h2>Be the First to Know</h2>
        <p>Subscribe for updates and early access!</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <button type="submit">Subscribe</button>
        </form>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; 2025 FitItFirst. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
